import { configureStore, Middleware } from '@reduxjs/toolkit'
import { apis } from 'api'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import * as reducers from 'store'

import { AppDispatch, RootState } from 'types'

export const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: {
    ...reducers,
    ...apis.reduce((acc, api) => {
      acc[api.reducerPath] = api.reducer

      return acc
    }, {} as Record<string, any>),
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(...(apis.map(api => api.middleware) as Middleware[])),
})
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
